import type { FC } from 'react';
import { useEffect, useState } from 'react';
import icons from '@icons';
import { observer } from 'mobx-react';
import { Picture } from '@ui';
import { when } from 'mobx';
import { Link } from '@compat/router';
import './index.scss';
import { useStores } from '@root/src/stores';

const {
  heart: { black: heartBlackFilled, red: heartRedFilled }
} = icons.Fill;
const {
  heart: { black: heartBlackOutlined, red: heartRedOutlined }
} = icons.Outline;

interface LikesBtnProps {
  compact?: boolean;
}

const LikesBtn: FC<LikesBtnProps> = observer(({ compact = false }) => {
  const { userStore, catalogStore, modalsStore } = useStores();
  const { isUserLoggedIn } = userStore;
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    const disposer = when(
      () => userStore.isLoad && userStore.isUserLoggedIn,
      () => {
        catalogStore.getTotalFavorites();
      }
    );
    return disposer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (e): void => {
    if (!isUserLoggedIn) {
      e.preventDefault();
      modalsStore.changeAuthModalState();
    } else {
      window?.dataLayer?.push({ event: 'webit_click_favorites' });
    }
  };

  const onMouseEnter = (): void => {
    setIsHovered(true);
  };
  const onMouseLeave = (): void => {
    setIsHovered(false);
  };
  const icon = compact
    ? isHovered
      ? heartRedOutlined
      : heartBlackOutlined
    : isHovered
    ? heartRedFilled.x2
    : heartBlackFilled.x2;
  return (
    <Link
      onClick={handleClick}
      to={'/cabinet/products'}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`likes-btn${compact ? ' likes-btn--compact' : ''}`}
    >
      {catalogStore?.favoritesItemsAmount && (
        <div className='likes-btn__count'>
          {catalogStore.favoritesItemsAmount}
        </div>
      )}
      <Picture icon={icon} width={compact ? '24' : '20'} height={compact ? '24' : '20'} />
      <div className='likes-btn__tooltip'>Мои любимые товары</div>
    </Link>
  );
});

export default LikesBtn;
